import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import { loadFonts } from './plugins/webfontloader'
import './styles/shared.css'

loadFonts()

createApp(App).use(vuetify).use(router).mount('#app')
